<template>
  <div id="aula-login">
    <div id="main">
      <div id="aula-choose-portal-role">
        <b-container>
          <div class="aula-logo" role="heading" aria-level="1">
            <span class="sr-only">{{ $getText('ARIA_LABEL_AULA_LOGIN') }}</span>
            <i class="icon-Logo" aria-hidden="true" />
          </div>
          <b-row>
            <b-col cols="12" class="login-method">
              {{ $getText('LOGIN_PAGE_CHOOSE_LOGIN_METHOD') }}
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center box-container mt-4">
            <b-col cols="12" lg="4">
              <div
                class="square-box login-option"
                tabindex="0"
                role="button"
                @click="selectPortalRole('guardian')"
                @keydown.enter="selectPortalRole('guardian')"
              >
                <div class="content">
                  {{ $getText('PARENT') }}
                </div>
                <i v-if="!isMobile" class="icon-Aula_forward-arrow" />
              </div>
            </b-col>
            <b-col cols="12" lg="4">
              <div
                class="square-box login-option"
                tabindex="0"
                role="button"
                @click="selectPortalRole('otp')"
                @keydown.enter="selectPortalRole('otp')"
              >
                <div class="content">{{ $getText('OTP') }}<br /></div>
                <i v-if="!isMobile" class="icon-Aula_forward-arrow" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '../../../src/store/types/types';
import { parentTypes } from '../../enums/parentTypes.ts';
import { portalRoles } from '../../enums/portalRoles';
import { useUserProfileStore } from '../../stores';

export default {
  computed: {
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    isProfileLoaded() {
      return this.userProfileStore.isLoading === false;
    },
  },
  methods: {
    selectPortalRole(method) {
      if (method == 'guardian') {
        this.getProfileContext({
          portalrole: portalRoles.GUARDIAN,
          parent: parentTypes.PORTAL,
        }).then(profile => {
          this.$router.push({ name: 'overblik' });
          this.userProfileStore.setProfile(profile);
          this.userProfileStore.setLoading(false);
        });
      } else {
        this.getProfileContext({
          portalrole: portalRoles.OTP,
          parent: parentTypes.PORTAL,
        }).then(profile => {
          this.$router.push({ name: 'overblik' });
          this.userProfileStore.setProfile(profile);
          this.userProfileStore.setLoading(false);
        });
      }
    },
    ...mapActions({
      getProfileContext: types.ACTION_GET_PROFILE_CONTEXT,
    }),
    mounted() {
      if (!this.isProfileLoaded) {
        this.$router.push({ name: 'login' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/components/login/login' as *;
</style>
